/* constants */
import estados from "@/constants/repositorio/estados"
import cidades from "@/constants/repositorio/cidades"
import nacionalidade from "@/constants/repositorio/nacionalidade"
import orgaoEmissor from "@/constants/repositorio/orgao_emissor"

export default {
  namespaced: true,
  state: {
    states: estados,
    cities: cidades,
    nacionalidades: nacionalidade,
    orgaoEmissor: orgaoEmissor
  },
  getters: {
    getStates: (state) => state.states,
    getCities: (state) => state.cities,
    getNacionalidades: (state) => state.nacionalidades,
    getOrgaoEmissor: (state) => state.orgaoEmissor
  },
  mutations: {
    UPDATE_CITIES (state) {
      state.cities = cidades
      state.states = estados
    },
  },
  actions: {
    update ({ commit }) {
      commit('UPDATE_CITIES')
    }
  }
}
